import './css/normalize.css';
import './css/libs.css';
// import './css/vendor/slimselect.scss';
import 'slim-select/src/slim-select/slimselect.scss';
import './css/fonts.css';
import './css/body-colors.css';
import './css/base.css';
import './css/contact.css';
import './js/_shims';
import App from './js/app';
const app = new App();

app.init();
